import { themeColors } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import {
  Icon,
  Skeleton,
  Tabs,
  Title,
} from "@tudigo-monorepo/web-tudigo-components";

export function ParticipationsAssemblyDetailPageSkeleton() {
  const { t } = useTranslation();

  return (
    <>
      <div className="border-light-1 mx-6 flex flex-col gap-4 border-b py-4">
        <div className="flex flex-row gap-4">
          <Icon name="Assemblies" primaryColor={themeColors["medium-1"]} />
          <Icon
            name="ChevronRight"
            width={18}
            height={18}
            primaryColor={themeColors["medium-1"]}
          />
        </div>
        <Skeleton className="h-7 w-[123px] rounded" />
        <Title className="heading200">
          {t("assembly_detail_page.head.title")}
        </Title>
        <div className="flex items-center gap-4">
          <Skeleton className="h-7 w-48 rounded" />
          <Skeleton className="h-7 w-[134px] rounded" />
          <Skeleton className="h-7 w-[88px] rounded" />
        </div>
      </div>
      <Tabs
        tabs={[
          {
            name: t("assembly_detail_page.tab.vote"),
            redirectTo: "vote",
          },
          {
            name: t("assembly_detail_page.tab.documents"),
            redirectTo: "documents",
          },
        ]}
        className="px-6 py-4"
      />
      <div className="flex w-full items-center gap-4 px-6">
        <Skeleton className="h-[371px] w-1/2 rounded" />
        <Skeleton className="h-[371px] w-1/2 rounded" />
      </div>
    </>
  );
}
